@if (shouldShowTopNav) {
  <app-borrower-nav
    [entitlementData]="entitlementDataForBorrowerNav"
  ></app-borrower-nav>
}
<div id="main" class="pull-right background">
  <router-outlet></router-outlet>
</div>
